import { 
  User, 
  Users, 
  Building, 
  Briefcase, 
  FileText, 
  FileCheck, 
  Mail, 
  Phone, 
  MapPin, 
  Globe, 
  Calendar, 
  Clock, 
  DollarSign, 
  CreditCard, 
  Shield, 
  Lock, 
  Heart, 
  Star, 
  MessageSquare, 
  HelpCircle,
  Info,
  Home,
  School,
  Award,
  Target,
  Clipboard,
  Settings,
  Package,
  LucideIcon
} from 'lucide-react';

// Icon key to Lucide component mapping
export const ICON_MAPPINGS: Record<string, LucideIcon> = {
  // Personal & Contact
  'user': User,
  'users': Users,
  'mail': Mail,
  'phone': Phone,
  'home': Home,
  
  // Business & Work
  'building': Building,
  'briefcase': Briefcase,
  'school': School,
  'award': Award,
  
  // Documents & Forms
  'file_text': FileText,
  'file_check': FileCheck,
  'clipboard': Clipboard,
  
  // Location & Time
  'map_pin': MapPin,
  'globe': Globe,
  'calendar': Calendar,
  'clock': Clock,
  
  // Finance
  'dollar_sign': DollarSign,
  'credit_card': CreditCard,
  
  // Other
  'shield': Shield,
  'lock': Lock,
  'heart': Heart,
  'star': Star,
  'message_square': MessageSquare,
  'help_circle': HelpCircle,
  'info': Info,
  'target': Target,
  'settings': Settings,
  'package': Package,
};

/**
 * Get the Lucide icon component for a given icon key
 * @param iconKey - The lowercase icon key (e.g., 'user', 'building')
 * @returns The Lucide icon component or undefined if not found
 */
export function getIconComponent(iconKey?: string): LucideIcon | undefined {
  if (!iconKey) return undefined;
  return ICON_MAPPINGS[iconKey];
}